<template>
  <div class="home">
    <div class="grid">
      <span class="hda-top-bar">
        <p class="title-text">Hypotension Decision Assist (HDA)&trade;</p>
        <div>
          <p class="time-text">{{ timestamp }}</p>
        </div>
      </span>
      <Launchscreen
        v-if="screen === 'launch'"
        class="content"
        @start-patient-session="startPatientSession"
      ></Launchscreen>
      <RunningMode
        v-else-if="screen === 'runningmode'"
        class="content"
        @stop-patient-session="stopPatientSession"
      ></RunningMode>
    </div>
    <div id="brightness-filter" :style="{ opacity: filterOpacity }"></div>
  </div>
</template>

<script>
import Launchscreen from '../views/Launchscreen'
import RunningMode from '../views/RunningMode'

export default {
  name: 'Home',
  data() {
    return {
      screen: 'launch'
    }
  },
  computed: {
    timestamp() {
      return this.$store.state.timestamp
    },
    filterOpacity() {
      return 1 - this.$store.state.brightness
    }
  },
  components: {
    Launchscreen,
    RunningMode
  },
  methods: {
    startPatientSession() {
      this.setSessionDefaults()
      this.screen = 'runningmode'
    },
    openConfigMode() {
      alert('config mode')
    },
    stopPatientSession() {
      this.screen = 'launch'
    },
    setSessionDefaults() {
      this.$store.commit('setBPTargetMin', 65)
      this.$store.commit('setBPTargetMax', 85)
    }
  }
}
</script>

<style scoped>
.home {
  width: 90vw;
  /* 90% of viewport vidth */
  height: 50.625vw;
  /* ratio = 9/16 * 90 = 50.625 */
  background-color: #010201;
  max-height: 90vh;
  max-width: 160vh;
  /* 16/9 * 90 = 160 */
  margin: 2% auto;
  position: relative;
  /*drop shadow to the bottom right*/
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
}
.grid {
  position: absolute;
  height: 100%;
  width: 100%;
  /* Grid */
  background: #add4c8;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 2.6% 97.4%;
}
.hda-top-bar {
  grid-row: 1;
  background-color: #00413b;
  font-size: 0.9vw;
}

.content {
  grid-row: 2;
}

.title-text {
  color: white;
  float: left;
  margin: 0 0 0 10px;
}
.time-text {
  color: white;
  float: right;
  margin: 0 10px 0 0;
}
#brightness-filter {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 9;
  background-color: black;
  pointer-events: none;
}
</style>
